/*
Replace
resourceName with your resource Name :) Take care about different writings!
/!\ Analytic analytic authConnect authConnect /!\
Keep an eye on pluralized namings in here :)
*/

import { createSlice } from "@reduxjs/toolkit";

export const authConnectSlice = createSlice({
  name: "authConnect",
  initialState: { status: null },
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
  },
});

export const { setStatus } = authConnectSlice.actions;

export const actions = authConnectSlice.actions;

export default authConnectSlice.reducer;
